module.exports = __webpack_public_path__ + "static/media/design.11b98b03.png";